import { Link, navigate } from 'gatsby'
import React, { useEffect, useState } from 'react'
import {
	AppBar,
	Button,
	Menu,
	MenuItem,
	Toolbar,
	Typography,
	Drawer,
	IconButton,
	useTheme,
	useMediaQuery,
	Box
} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import CloseIcon from '@mui/icons-material/Close'
import logo from '../images/logo.png'
import logoColor from '../images/logo-color.png'
import { logout, isBrowser } from '../services/auth'

const Header = ({ active }) => {
	const theme = useTheme()
	const matches = useMediaQuery(theme.breakpoints.up('md'))
	const [open, setOpen] = useState(false)
	const [anchorEl, setAnchorEl] = useState(null)

	const toggleDrawerMenu = () => (event) => {
		if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return
		}
		setOpen(!open)
	}

	const toggleProfileMenu = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleCloseProfileMenu = () => {
		setAnchorEl(null)
	}

	const handleMyAccount = () => {
		navigate(`/app/profile`)
	}

	const handleLogout = () => {
		setAnchorEl(null)
		logout(() => navigate('/'))
	}

	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [role, setRole] = useState(null)

	useEffect(() => {
		const user =
			isBrowser() && window.localStorage.getItem('gatsbyUser')
				? JSON.parse(window.localStorage.getItem('gatsbyUser'))
				: {}
		setIsLoggedIn(!!user.token)
		setRole(user.user != null ? user.user.role.type : null)
	}, [active, anchorEl])

	return (
		<AppBar position='static' elevation={0} sx={{ pb: 2, backgroundColor: theme.palette.common.white }}>
			<Toolbar>
				<Link to='/' style={{ flexGrow: 1, mr: theme.spacing(3) }}>
					{active === 'home' ? (
						<Box src={logoColor} alt='Logo' component='img' />
					) : (
						<Box src={logo} alt='Logo' component='img' />
					)}
				</Link>
				{matches ? (
					role !== 'usersearch' ? (
						<nav>
							<Link
								to='/job/list'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'jobs'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Jobs
								</Typography>
							</Link>
							<Link
								to='/tender/list'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'tenders'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Tenders
								</Typography>
							</Link>
							<Link
								to='/training/list'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'trainings'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Trainings
								</Typography>
							</Link>
							<Link
								to='/career/list'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'careers'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Career Guide
								</Typography>
							</Link>
							<Link
								to='/serviceprovider/list'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'serviceproviders'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Service Providers
								</Typography>
							</Link>
							<Link
								to='/faq'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === 'faq'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Faq/resources
								</Typography>
							</Link>
						</nav>
					) : (
						<nav>
							<Link
								to='/app/users'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === '/app/users/'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Users
								</Typography>
							</Link>
							<Link
								to='/app/quizzerstats'
								style={{
									marginRight: theme.spacing(3),
									textDecoration: 'none',
									display: 'inline-block'
								}}
							>
								<Typography
									variant='button'
									color='secondary'
									sx={
										active === '/app/quizzerstats/'
											? {
													borderBottom: `5px solid ${theme.palette.secondary.main}`,
													pb: '4px',
													fontSize: '1.5rem',
													textTransform: 'none'
											  }
											: { fontSize: '1.5rem', textTransform: 'none' }
									}
								>
									Quizzer statistics
								</Typography>
							</Link>
						</nav>
					)
				) : (
					<>
						<IconButton color='secondary' onClick={toggleDrawerMenu()} edge='start'>
							<MenuIcon />
						</IconButton>
						<Drawer
							anchor='right'
							open={open}
							onClose={toggleDrawerMenu()}
							sx={{
								'& >div': {
									height: 'auto'
								}
							}}
						>
							<Box
								sx={{
									backgroundColor: theme.palette.primary.main,
									display: 'flex',
									justifyContent: 'flex-end',
									p: 2.5
								}}
							>
								<IconButton onClick={toggleDrawerMenu()} edge='start' color='#fff'>
									<CloseIcon />
								</IconButton>
							</Box>
							{role !== 'usersearch' ? (
								<nav
									style={{
										backgroundColor: theme.palette.primary.main,
										display: 'flex',
										flexDirection: 'column',
										padding: 20,
										color: '#fff',
										minWidth: 300
									}}
								>
									<Link
										to='/job/list'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											sx={
												active === 'jobs'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Jobs
										</Typography>
									</Link>
									<Link
										to='/tender/list'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											sx={
												active === 'tenders'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Tenders
										</Typography>
									</Link>
									<Link
										to='/training/list'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											sx={
												active === 'trainers'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Trainings
										</Typography>
									</Link>
									<Link
										to='/career/list'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											sx={
												active === 'careers'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Career Guide
										</Typography>
									</Link>
									<Link
										to='/serviceprovider/list'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											color='secondary'
											sx={
												active === 'serviceproviders'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Service Providers
										</Typography>
									</Link>
									<Link
										to='/faq'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											sx={
												active === 'faq'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Faq/resources
										</Typography>
									</Link>
								</nav>
							) : (
								<nav
									style={{
										backgroundColor: theme.palette.primary.main,
										display: 'flex',
										flexDirection: 'column',
										padding: 20,
										color: '#fff',
										minWidth: 300
									}}
								>
									<Link
										to='/app/users'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											color='secondary'
											sx={
												active === '/app/users/'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Users
										</Typography>
									</Link>
									<Link
										to='/app/quizzerstats'
										style={{ textDecoration: 'none', color: '#fff', margin: 12, '& >span': { fontSize: '1rem' } }}
									>
										<Typography
											variant='button'
											color='secondary'
											sx={
												active === '/app/quizzerstats/'
													? { borderBottom: `5px solid ${theme.palette.secondary.main}`, pb: '4px' }
													: null
											}
										>
											Quizzer statistics
										</Typography>
									</Link>
								</nav>
							)}
						</Drawer>
					</>
				)}

				{isLoggedIn ? (
					<>
						<IconButton
							color='secondary'
							variant='contained'
							onClick={toggleProfileMenu}
							edge='start'
							aria-controls='simple-menu'
							aria-haspopup='true'
						>
							<AccountCircleIcon />
						</IconButton>
						<Menu
							id='simple-menu'
							anchorEl={anchorEl}
							keepMounted
							open={Boolean(anchorEl)}
							onClose={handleCloseProfileMenu}
						>
							{role === 'authenticated' ? <MenuItem onClick={handleMyAccount}>My account</MenuItem> : null}
							<MenuItem onClick={handleLogout}>Logout</MenuItem>
						</Menu>
					</>
				) : (
					<Link
						to='/app/login'
						style={{
							marginRight: theme.spacing(3),
							textDecoration: 'none',
							display: 'inline-block',
							'& >span': { fontSize: '1.5rem', textTransform: 'none' }
						}}
					>
						<Button
							color='secondary'
							variant='contained'
							sx={{ marginRight: `-${theme.spacing(2)}px`, boxShadow: 'none', color: '#fff', textTransform: 'none' }}
						>
							Login/Register
						</Button>
					</Link>
				)}
			</Toolbar>
		</AppBar>
	)
}

export default Header
